export default {
  state: {
    preOrderId: ""
  },
  mutations: {
    updatePreOrderId(state, payload) {
      state.preOrderId = payload;
    }
  }
};
